import gql from 'graphql-tag';

const STORE_DELETE_MUTATION = gql`
    mutation storeDelete ($id: ID!) {
        storeDelete (id: $id)
    }
`;

export default STORE_DELETE_MUTATION;